import { useEffect } from "react";
import { ComponentesDataTable } from "src/components/componentes/ComponentesDataTable";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Componentes"

const Componentes = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ComponentesDataTable />
        </div>
      </div>
    </div>
  );
};

export { Componentes };
